import { useNavigate } from "react-router";
import { useAppDispatch } from "../../../../app/hooks";
import { GridCellProps } from "@progress/kendo-react-grid";
import React from "react";
import { GridButton } from "../../../../components";

function ScheduleSearchCommand(props:GridCellProps) {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    return <React.Fragment>
        <GridButton variant='outlined' size='small' onClick={() => {
            navigate('/ScheduleDetail/' + props.dataItem.id);
            dispatch(props.dataItem.invalidateTags(['ScheduleSearch']));
        }}>
            View
        </GridButton>
    </React.Fragment>
}

export { ScheduleSearchCommand };